import { render, staticRenderFns } from "./Portrait.vue?vue&type=template&id=e6f13f6c&scoped=true"
import script from "./Portrait.vue?vue&type=script&lang=js"
export * from "./Portrait.vue?vue&type=script&lang=js"
import style0 from "./Portrait.vue?vue&type=style&index=0&id=e6f13f6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f13f6c",
  null
  
)

export default component.exports